// import { useEffect, useRef, useState } from "react";
// import Button from "@mui/material/Button";
// import InfoIcon from "@mui/icons-material/Info";
// import AddIcon from "@mui/icons-material/Add";
// import {
//   Avatar,
//   Badge,
//   Box,
//   Dialog,
//   DialogProps,
//   IconButton,
//   Link,
//   Modal,
//   Paper,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import Card from "../components/event-card/card";
// import SubscriptionView from "../components/subscription-view/subscription-view";
// import { getSubscriptionByUser } from "../services/subscription-service";
// import { SubscriptionResponse } from "../interfaces/subscription";
// import Loader from "../components/loader/loader";
// import Map, { MapImperativeHandle } from "../components/map/map";
// import "../styles/_home.scss";
// import LogoutIcon from "@mui/icons-material/Logout";
// import Person2Icon from "@mui/icons-material/Person2";
// import { useAuth } from "../services/auth/AuthContext";
// import UserProfile from "../components/view-profile/viewProfile";
// import React from "react";

// const style_modal = {
//   bgcolor: "background.paper",
//   boxShadow: 24,
// };

// export default function Home() {
//   const { userAttributes, signOut } = useAuth();
//   const [open, setOpen] = useState(false);
//   const [openProfile, setOpenProfile] = useState(false);
//   const [actualItemSelected, setActualItemSelected]: any = useState(null);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const handleOpenProfile = () => setOpenProfile(true);
//   const handleCloseProfile = () => setOpenProfile(false);
//   const [userSubs, setUserSubs]: any[] = useState();
//   const [isLoading, setIsLoading] = useState(false);
//   const refMap = useRef<MapImperativeHandle>(null);

//   // Muni SJ 9.931365026139131, -84.09516637453397
//   const [userLocation, setUserLocation]: any = useState({
//     latitude: 9.990269053995066,
//     longitude: -84.66707359259031,
//   });
//   // const [userLocation, setUserLocation]: any = useState({
//   //   latitude: 9.931365026139131,
//   //   longitude: -84.09516637453397,
//   // });

//   const [userZoom, setUserZoom]: any = useState(17);

//   const getUserSubscription = async () => {
//     setIsLoading(true);
//     const userId: any = userAttributes?.sub;
//     if (userId) {
//       setIsLoading(true);
//       try {
//         const userSubscription: SubscriptionResponse[] =
//           await getSubscriptionByUser(userId);
//         setUserSubs(userSubscription);
//         setIsLoading(false);
//       } catch {
//         setIsLoading(false);
//         setUserSubs([]);
//       }
//     } else {
//       setIsLoading(false);
//     }
//   };

//   const openItemDetail = (item: SubscriptionResponse) => {
//     setActualItemSelected(item);
//     handleOpen();
//   };

//   const callUserSubs = () => {
//     getUserSubscription();
//   };

//   const handleAddMarker = (element: any) => {
//     let markerPosition = element.notification_point.split(",");
//     markerPosition = [
//       parseFloat(markerPosition[0]),
//       parseFloat(markerPosition[1]),
//     ];

//     const marker = {
//       position: markerPosition,
//       name: element.name,
//       id: element.id,
//     };
//     if (refMap.current) {
//       refMap.current.addMarker(marker);
//     }
//   };

//   useEffect(() => {
//     getUserSubscription();
//   }, []);

//   return (
//     <div className="main_background flex flex-col  h-full full_heigth">
//       <div className="w-full flex lg:flex-row flex-col	h-full">
//         <div className="flex flex-col lg:w-1/4 w-full lg:h-full h-2/3 details_cont">
//           <div className="header_container flex content-center	items-center justify-center justify-items-center p-7  w-full">
//             <Avatar
//               className="badge_container"
//               alt="Badge"
//               sx={{
//                 width: 120,
//                 height: 120,
//                 bgcolor: "#00975d",
//                 color: "white",
//               }}
//             >
//               {userAttributes ? userAttributes?.given_name?.charAt(0) : "E"}
//             </Avatar>
//           </div>

//           <div className="flex flex-col  p-5 subscription-container">
//             {userAttributes && (
//               <div className="w-full mb-3 flex flex-row justify-between items-center">
//                 <h2>
//                   Bienvenido <strong>{userAttributes?.given_name}</strong>
//                 </h2>
//                 <Tooltip title={"Mi perfil"} placement="right-start">
//                   {!userAttributes!["custom:editProfile"] ? (
//                     <Badge badgeContent={"!"} color="error">
//                       <IconButton
//                         color="error"
//                         className="profile-button"
//                         onClick={handleOpenProfile}
//                       >
//                         <Person2Icon />
//                       </IconButton>
//                     </Badge>
//                   ) : (
//                     <IconButton
//                       color="primary"
//                       className="profile-button"
//                       onClick={handleOpenProfile}
//                     >
//                       <Person2Icon />
//                     </IconButton>
//                   )}
//                 </Tooltip>
//               </div>
//             )}
//             <h2 className="mb-3">Suscripciones activas</h2>
//             {isLoading && <Loader text="Cargando suscripciones" />}
//             {userSubs?.length > 0 &&
//               userSubs.map((sub: any) => (
//                 <Card
//                   key={sub.id}
//                   statusColor="blue"
//                   title={sub.name}
//                   description=""
//                   time=""
//                   handleOnClick={() => openItemDetail(sub)}
//                   handleClickIcon2={() => handleAddMarker(sub)}
//                 />
//               ))}

//             <div className="mt-5 button-container">
//               <div className="button-second-container">
//                 <Link
//                   href={
//                     userAttributes!["custom:editProfile"] ? "/event" : undefined
//                   } // Deshabilita la navegación si no está habilitado
//                   className={`mt-4 ${
//                     !userAttributes!["custom:editProfile"]
//                       ? "disabled-link"
//                       : ""
//                   }`}
//                   onClick={(e) => {
//                     if (!userAttributes!["custom:editProfile"]) {
//                       e.preventDefault(); // Evita la acción del clic si no está habilitado
//                     }
//                   }}
//                 >
//                   <Button
//                     disabled={!userAttributes!["custom:editProfile"]}
//                     variant="contained"
//                     startIcon={<AddIcon />}
//                   >
//                     Agregar nuevo evento
//                   </Button>
//                 </Link>
//               </div>
//               {!userAttributes!["custom:editProfile"] && (
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   mt={2}
//                   p={2}
//                   bgcolor="#f9f9f9"
//                   border="1px solid #ddd"
//                   borderRadius="8px"
//                 >
//                   <InfoIcon color="info" sx={{ mr: 1 }} />
//                   <Typography variant="body2" color="textSecondary">
//                     Antes de crear un evento, actualiza la información
//                     correspondiente en tu perfil.
//                   </Typography>
//                 </Box>
//               )}
//             </div>
//           </div>

//           <div className="logout-container mt-3">
//             <Tooltip title={"Cerrar Sesión"} placement="right-start">
//               <IconButton onClick={() => signOut()} aria-label="delete">
//                 <LogoutIcon />
//               </IconButton>
//             </Tooltip>
//           </div>
//         </div>

//         <div className="map_container lg:w-3/4 w-full h-full">
//           {
//             <Map
//               positionButtton
//               showFirstIcon={false}
//               ref={refMap}
//               zoom={userZoom}
//               shapefileUrl="https://garbage-collector-resources.s3.amazonaws.com/Recoleccion+Basura+(1).json"
//               height="100%"
//               initialPosition={[userLocation.latitude, userLocation.longitude]}
//             />
//           }
//         </div>
//       </div>
//       <Dialog
//         className="modal-container flex justify-center content-center items-center subscription-view-container"
//         open={open}
//         onClose={handleClose}
//         scroll={"paper"}
//       >
//         {/* <Paper className="modal-view-sub" sx={style_modal} scroll="body">*/}
//         {actualItemSelected && (
//           <SubscriptionView
//             handleOnClose={handleClose}
//             name={actualItemSelected.name}
//             id={actualItemSelected.id}
//             subscriptions={actualItemSelected.topics}
//             notification={actualItemSelected.notifications_method}
//             position={actualItemSelected.notification_point}
//             radious={actualItemSelected.radious}
//             onDeleteCallback={callUserSubs}
//           />
//         )}
//         {/* </Paper> */}
//       </Dialog>

//       <Modal
//         style={{ height: "100%" }}
//         className="modal-container  flex justify-center content-center items-center	"
//         open={openProfile}
//         onClose={handleCloseProfile}
//       >
//         <Paper className="modal-view-sub" sx={style_modal}>
//           {
//             <UserProfile
//               handleOnClose={handleCloseProfile}
//               onSave={() => console.log("saving")}
//               webPush={userAttributes?.["custom:webPush"]}
//               given_name={userAttributes?.given_name}
//               email={userAttributes?.email}
//               family_name={userAttributes?.family_name?.toString()}
//               phone_number_verified={
//                 userAttributes?.phone_number_verified === "true"
//               }
//               phone_number={
//                 userAttributes?.phone_number
//                   ? userAttributes?.phone_number === "+50611111111"
//                     ? ""
//                     : userAttributes?.phone_number
//                   : ""
//               }
//               editProfile={userAttributes?.["custom:editProfile"]}
//             />
//           }
//         </Paper>
//       </Modal>
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Link,
  Modal,
  Paper,
  Switch,
  Tooltip,
  Typography,
  Dialog,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import SyncIcon from "@mui/icons-material/Sync";
import Person2Icon from "@mui/icons-material/Person2";
import RoomIcon from "@mui/icons-material/Room";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";

import Map, { MapImperativeHandle } from "../components/map/map";
import SubscriptionView from "../components/subscription-view/subscription-view";
import UserProfile from "../components/view-profile/viewProfile";
import Loader from "../components/loader/loader";

import { api } from "../services/api";
import { SubscriptionResponse } from "../interfaces/subscription";
import { useAuth } from "../services/auth/AuthContext";

const style_modal = {
  bgcolor: "background.paper",
  boxShadow: 24,
};

type LocalSubState = {
  active: boolean; // toggle del UI (mock si tu API no trae activo/inactivo)
};

const StatusChip: React.FC<{ status?: string }> = ({ status }) => {
  // Mock visual si no hay estado en API. Mapea a los 3 estilos del diseño.
  const label = status || "On Route";
  const mapStyle =
    label.toLowerCase() === "on route"
      ? {
          sx: { bgcolor: "rgba(34,197,94,.15)", color: "#34D399" },
          text: "En ruta",
        }
      : label.toLowerCase() === "nearby"
      ? {
          sx: { bgcolor: "rgba(249,115,22,.15)", color: "#F59E0B" },
          text: "Cercana",
        }
      : {
          sx: { bgcolor: "rgba(107,114,128,.2)", color: "#9CA3AF" },
          text: "Ya pasó",
        };

  return (
    <Chip
      size="small"
      label={mapStyle.text}
      sx={{ ...mapStyle.sx, fontWeight: 600 }}
    />
  );
};

export default function Home() {
  const { userAttributes, signOut } = useAuth();

  // dialogs / modals
  const [openDetail, setOpenDetail] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [actualItemSelected, setActualItemSelected] =
    useState<SubscriptionResponse | null>(null);

  const [userSubs, setUserSubs] = useState<
    SubscriptionResponse[] | undefined
  >();
  const [isLoading, setIsLoading] = useState(false);

  const refMap = useRef<MapImperativeHandle>(null);

  // San José (mock pos inicial). Tu código ya tiene coords, puedes mantenerlos:
  const [userLocation] = useState({
    latitude: 9.990269053995066,
    longitude: -84.66707359259031,
  });
  const [userZoom] = useState<number>(13);

  // Estado local para switches (no pisa tu API):
  const [localSubState, setLocalSubState] = useState<
    Record<string, LocalSubState>
  >({});

  const ensureLocalSubState = (subs: SubscriptionResponse[]) => {
    console.log(subs, 2222);
    if (subs.length > 0) {
      setLocalSubState((prev) => {
        const next = { ...prev };
        subs.forEach((s) => {
          const key = String(s.id);
          if (!next[key]) next[key] = { active: true };
        });
        return next;
      });
    }
  };

  const getUserSubscription = async () => {
    const userId: any = userAttributes?.sub;
    if (!userId) {
      setUserSubs([]);
      return;
    }
    setIsLoading(true);
    try {
      const res = await api.subscriptions.getByUser(userId);
      if (res) {
        console.log(res, 12333);
        setUserSubs(res);
        ensureLocalSubState(res);
      } else {
        console.log(res, "errorrrrr");
        setUserSubs([]);
      }
    } catch {
      console.log("catchhhh");
      setUserSubs([]); // vacío pero UI sigue funcionando
    } finally {
      setIsLoading(false);
    }
  };

  const openItemDetail = (item: SubscriptionResponse) => {
    setActualItemSelected(item);
    setOpenDetail(true);
  };

  const handleAddMarker = (element: SubscriptionResponse) => {
    // Tu lógica original
    let markerPosition: any =
      (element as any).notification_point?.split(",") || [];
    markerPosition = [
      parseFloat(markerPosition[0]),
      parseFloat(markerPosition[1]),
    ];

    const marker = {
      position: markerPosition,
      name: element.name as any,
      id: element.id as any,
    };

    if (refMap.current) {
      refMap.current.addMarker(marker);
      // Si tu Map expone flyTo, centramos; si no, no pasa nada.
      (refMap.current as any)?.flyTo?.(markerPosition, 16);
    }
  };

  // const onToggleActive = (id: string | number) => {
  //   const key = String(id);
  //   setLocalSubState((prev) => ({
  //     ...prev,
  //     [key]: { active: !prev[key]?.active },
  //   }));
  // };

  const onToggleActive = (sub: SubscriptionResponse) => {
    const key = String(sub.id);
    const nextVisible = !(localSubState[key]?.active ?? true);

    // actualiza estado local del switch
    setLocalSubState((prev) => ({
      ...prev,
      [key]: { active: !nextVisible }, // active = true → visible
    }));

    // sincroniza con el mapa
    if (nextVisible) {
      // si lo activan: asegúrate de agregar/actualizar el marcador y mostrarlo
      refMap.current?.addMarker({
        id: sub.id,
        name: sub.name,
        position: sub.notification_point
          ? (sub.notification_point
              .split(",")
              .map((v: string) => parseFloat(v)) as [number, number])
          : [userLocation.latitude, userLocation.longitude],
        radius: parseInt(sub.radious) ?? 0, // dibuja círculo si viene definido
      });
      // refMap.current?.setMarkerVisibility(sub.id, true);
    } else {
      // si lo apagan: solo ocultar (o podrías removeMarker para borrarlo del todo)
      // refMap.current?.setMarkerVisibility(sub.id, false);
    }
  };

  const callUserSubs = () => {
    getUserSubscription();
  };

  useEffect(() => {
    getUserSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Helpers UI
  const WelcomeHeader = (
    <div className="flex flex-col items-center py-6 border-b border-gray-700/50">
      <Avatar sx={{ bgcolor: "#00E0FF", width: 64, height: 64 }}>
        {userAttributes?.given_name?.[0]?.toUpperCase() || "B"}
      </Avatar>
      <Typography variant="h6" className="mt-2 text-white">
        Bienvenido(a) {userAttributes?.given_name || "Bryan"}
      </Typography>
      {/* <Typography variant="body2" color="rgba(255,255,255,.6)">
        Tracking Manager
      </Typography> */}
    </div>
  );

  return (
    <div className="flex flex-col lg:flex-row h-dvh w-full min-h-0">
      {/* Sidebar */}
      <div className="w-full lg:w-1/4 bg-gradient-to-b from-[#0b1f3a] to-[#08182e] text-white flex flex-col min-h-0">
        {/* Header fijo */}
        <div>{WelcomeHeader}</div>

        {/* Lista scrollable */}
        <div className="p-4 flex-1 min-h-0 overflow-y-auto">
          <Typography variant="subtitle1" className="mb-3 text-gray-300">
            Suscripciones activas
          </Typography>

          {isLoading && <Loader text="Cargando suscripciones" />}

          {!isLoading && (userSubs?.length ?? 0) === 0 && (
            <Box className="p-4 rounded-xl bg-white/10 text-gray-300">
              Aún no tienes suscripciones.
            </Box>
          )}

          {userSubs?.map((sub: any) => {
            const key = String(sub.id);
            const active = localSubState[key]?.active ?? true;
            const distance = sub.distance_text || sub.distance || "—";
            const statusText =
              sub.status ||
              sub.state ||
              sub.tag ||
              (active ? "On Route" : "Already Passed");

            return (
              <Box
                key={sub.id}
                className={`p-3 rounded-xl mb-3 flex flex-col transition ${
                  active
                    ? "bg-white/10 hover:bg-white/20"
                    : "bg-gray-700/40 hover:bg-gray-600/40"
                }`}
              >
                <div className="flex justify-between items-start gap-2">
                  <div className="min-w-0">
                    <Typography variant="body1" fontWeight={700} noWrap>
                      {sub.name}
                    </Typography>
                    {/* <Typography variant="body2" color="rgba(255,255,255,.7)">
                      Distancia: {distance}
                    </Typography> */}
                  </div>
                  {/* Switch opcional */}
                  {/* <Switch checked={!!localSubState[String(sub.id)]?.active} onChange={() => onToggleActive(sub)} size="small" /> */}
                </div>

                <div className="flex justify-between items-center mt-2">
                  <StatusChip status={statusText} />
                  <div className="flex gap-1">
                    <Tooltip title="Ver detalle">
                      <IconButton
                        size="small"
                        color="info"
                        onClick={() => openItemDetail(sub)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver en el mapa">
                      <IconButton
                        size="small"
                        color="info"
                        onClick={() => handleAddMarker(sub)}
                      >
                        <RoomIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </Box>
            );
          })}

          <Link
            href={userAttributes?.["custom:editProfile"] ? "/event" : undefined}
            className={`block ${
              !userAttributes?.["custom:editProfile"]
                ? "pointer-events-none"
                : ""
            }`}
            onClick={(e) => {
              if (!userAttributes?.["custom:editProfile"]) e.preventDefault();
            }}
          >
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              disabled={!userAttributes?.["custom:editProfile"]}
              sx={{
                mt: 2,
                bgcolor: "#0066FF",
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 700,
                py: 1.2,
              }}
            >
              Agregar nueva suscripción
            </Button>
          </Link>

          {!userAttributes?.["custom:editProfile"] && (
            <Box
              display="flex"
              alignItems="center"
              mt={2}
              p={2}
              sx={{ bgcolor: "rgba(255,255,255,.06)", borderRadius: "10px" }}
            >
              <InfoIcon color="info" sx={{ mr: 1 }} />
              <Typography variant="body2" color="rgba(255,255,255,.7)">
                Antes de crear un evento, actualiza la información en tu perfil.
              </Typography>
            </Box>
          )}
        </div>

        {/* Footer fijo */}
        <div className="p-4 border-t border-gray-700/50 flex justify-between items-center text-gray-300 text-sm">
          <div className="flex gap-2">
            <Tooltip title="Ajustes">
              <IconButton
                color="inherit"
                size="small"
                onClick={() => setOpenProfile(true)}
              >
                <SettingsIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Sincronizar">
              <IconButton
                color="inherit"
                size="small"
                onClick={getUserSubscription}
              >
                <SyncIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
          <Tooltip title="Cerrar sesión">
            <IconButton color="inherit" size="small" onClick={() => signOut()}>
              <LogoutIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* Mapa */}
      <div className="w-full h-[50dvh] lg:flex-1 lg:h-auto relative">
        <Map
          positionButtton
          showFirstIcon={false}
          ref={refMap}
          zoom={userZoom}
          shapefileUrl="https://garbage-collector-resources.s3.amazonaws.com/Recoleccion+Basura+(1).json"
          height="100%"
          // En mobile (columna), el mapa usa h-[50dvh]; en desktop (fila), crece con flex-1
          initialPosition={[userLocation.latitude, userLocation.longitude]}
        />
      </div>

      {/* Dialogs igual que antes */}
      <Dialog
        className="modal-container flex justify-center content-center items-center subscription-view-container"
        open={openDetail}
        onClose={() => setOpenDetail(false)}
        scroll="paper"
      >
        {actualItemSelected && (
          <SubscriptionView
            handleOnClose={() => setOpenDetail(false)}
            name={actualItemSelected.name}
            id={actualItemSelected.id}
            subscriptions={(actualItemSelected as any).topics}
            notification={(actualItemSelected as any).notifications_method}
            position={(actualItemSelected as any).notification_point}
            radious={(actualItemSelected as any).radious}
            onDeleteCallback={callUserSubs}
          />
        )}
      </Dialog>

      <Modal
        style={{ height: "100%" }}
        className="modal-container flex justify-center content-center items-center"
        open={openProfile}
        onClose={() => setOpenProfile(false)}
      >
        <Paper
          className="modal-view-sub"
          sx={{ bgcolor: "background.paper", boxShadow: 24 }}
        >
          <UserProfile
            handleOnClose={() => setOpenProfile(false)}
            onSave={() => console.log("saving")}
            webPush={userAttributes?.["custom:webPush"]}
            given_name={userAttributes?.given_name}
            email={userAttributes?.email}
            family_name={userAttributes?.family_name?.toString()}
            phone_number_verified={
              userAttributes?.phone_number_verified === "true"
            }
            phone_number={
              userAttributes?.phone_number
                ? userAttributes?.phone_number === "+50611111111"
                  ? ""
                  : (userAttributes?.phone_number as string)
                : ""
            }
            editProfile={userAttributes?.["custom:editProfile"]}
          />
        </Paper>
      </Modal>
    </div>
  );
}
